import { FC, Fragment, useState } from 'react'
import { Button } from './Button'
import { useTranslation } from 'react-i18next'
import { Box, Dialog, Typography, styled } from '@mui/material';
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import DomPurify from 'dompurify'
import ReactHtmlParser from 'react-html-parser'

const InstructionsModal: FC<any> = (props) => {
    const { open, onClose, title, header, children } = props


    return (
        <Dialog
            fullWidth
            scroll={'body'}
            open={open}
            onClose={onClose}
            aria-labelledby={title}
            aria-describedby={title}
        >
            <ModalBox>
                {header ? (
                    header
                ) : (
                    <ModalHeader>
                        <Typography sx={{
                             fontSize: '24px',
                             fontWeight: 'normal',
                             color: '#282828',
                        }}>
                            {title}
                        </Typography>
                        <CloseIcon>
                            <IconButton onClick={onClose} size="large">
                                <Icon name="Close" color="#959598" />
                            </IconButton>
                        </CloseIcon>
                    </ModalHeader>
                )}

                {children}
            </ModalBox>
        </Dialog>
    );
}



export type InstructionsProps = {
    title: string
    instructions: string
    button?: any
}
export const Instructions: FC<InstructionsProps> = (props) => {
    const { t } = useTranslation()

    const [showModal, setShowModal] = useState(false)

   

    const header = (
        <InstructionsModalHeader >
            <Typography sx={{
                 fontSize: '16px',
                 fontWeight: 'bold',
                 color: '#000000',
            }}>{props.title}</Typography>
            <CloseIconInstructions >
                <Icon
                    name="Close"
                    color="#000000"
                    onClick={() => setShowModal(false)}
                />
            </CloseIconInstructions>
        </InstructionsModalHeader>
    )

    const parsedHtml = ReactHtmlParser(DomPurify.sanitize(props.instructions))

    return (
        <Fragment>
            {props.button ? (
                props.button(setShowModal)
            ) : (
                <Button onClick={() => setShowModal(true)}>
                    {t('MoreInfo')}
                </Button>
            )}
            <InstructionsModal open={showModal} header={header}>
                <ContentBox>{parsedHtml}</ContentBox>
            </InstructionsModal>
        </Fragment>
    )
}


const ModalBox = styled(Box)({
    backgroundColor: '#f7f8fa',
    borderRadius: '8px',
    padding: 0,
    '&:focus': {
        outline: 'none',
    },
})
const ModalHeader = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '20px',
    padding: '16px 8px',
})
const CloseIcon = styled(Box)({
    display: 'flex',
    marginRight: '-16px',
    marginTop: '-16px',
    height: '10px',
})
const InstructionsModalHeader = styled(Box)({
    padding: '16px 16px',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
})
const ContentBox = styled(Box)({
    color: '#000000',
    marginTop: '36px',
    padding: '16px',
    backgroundColor: '#ffffff',
})
const CloseIconInstructions = styled(Box)({
    position: 'absolute',
    right: 20,
    top: 16,
    height: '10px',
    cursor: 'pointer',
})
